import { Suspense, useState } from 'react'

import type { Collection } from '@tribeplatform/gql-client/types'
import { CollectionFormModal } from '@tribeplatform/react-components/Collection'
import { T } from '@tribeplatform/react-components/i18n'
import { cn } from '@tribeplatform/react-components/utils/cn'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Link } from '@tribeplatform/react-ui-kit/Link'
import {
  NavVertical,
  NavVerticalItemProps,
} from '@tribeplatform/react-ui-kit/Sidebar'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

interface AddCollectionProps extends NavVerticalItemProps {
  onSuccess?: (collection: Collection) => void
}

export function AddCollection({
  className,
  onSuccess,
  ...props
}: AddCollectionProps) {
  const [openCollectionModal, setOpenCollectionModal] = useState(false)

  return (
    <>
      <NavVertical.Item
        as={Link}
        leadingIcon={<SvgIcon name="folder-plus" size="lg" />}
        className={cn('mb-1', className)}
        onClick={() => {
          setOpenCollectionModal(true)
        }}
        {...props}
      >
        <div className="flex-1 truncate">
          <T defaultMessage="Add {COLLECTION}" id="Generics.AddCollection" />
          <Tooltip>
            <Tooltip.Trigger className="inline-block">
              <SvgIcon
                inline
                className="ms-1 shrink-0"
                name="alert-circle"
                size="sm"
              />
            </Tooltip.Trigger>
            <Tooltip.Panel>
              <T
                defaultMessage="Group multiple spaces together into a collection for better organization."
                id="Admin.CollectionsAndSpaces.CreateCollectionTooltip"
              />
            </Tooltip.Panel>
          </Tooltip>
        </div>
      </NavVertical.Item>
      <Suspense fallback={<></>}>
        <CollectionFormModal
          open={openCollectionModal}
          onClose={() => {
            setOpenCollectionModal(false)
          }}
          onSuccess={onSuccess}
        />
      </Suspense>
    </>
  )
}
